import Vue from 'vue'
import Vuex from 'vuex'


import VuexPersistence from 'vuex-persist'
import * as actions from './actions'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    invoiceNo: 0
  },
  actions,
  mutations: {
    LogIn(state) {
      state.isLoggedIn = true
    },
    LogOut(state) {
      state.isLoggedIn = false
    },
    setInvoiceNo(state,invoiceNo) {
      console.log(invoiceNo)
      state.invoiceNo = invoiceNo
    }
  },

  plugins: [vuexLocal.plugin]
})